import React from 'react';

import Truncate from 'react-truncate';
import Cast from '@/Components/Cast';
import { Maybe, Character } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import useMedia from '@/Hooks/useMedia';
import classnames from 'classnames';
import { isEmpty, isNil } from 'ramda';
import styles from './styles.module.scss';

interface Props {
  synopsis: string | null | undefined;
  cast?: Maybe<Character>[] | undefined;
  className?: string;
  hasPkgUpgrade?: boolean;
}

const Synopsis: React.FC<Props> = props => {
  const { isMediaM } = useMedia();
  const { synopsis, cast, className, hasPkgUpgrade } = props;
  const truncLines = isMediaM ? 5 : 6;
  return (
    <div className={(classnames(className), styles.synopsis)} data-testid="synopsis">
      <Truncate lines={truncLines} trimWhitespace>
        {synopsis}
      </Truncate>
      {!isNil(cast) && !isEmpty(cast) && !hasPkgUpgrade && <Cast cast={cast} />}
    </div>
  );
};

export default Synopsis;
